import {api, headers} from './api';

const RESOURCE = 'penelitian_dosen';

export const dataPenelitianDosen = (id) => api.get(RESOURCE+'/data/'+id, headers);

export const storePenelitianDosen = (data) => api.post(RESOURCE, data, headers);